import { setAgrEnvironment, AgrProcessEnv, AgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  DAIRY_RATION_URL: string;
  LABRESULT_URL: string;

  constructor(env: Environment) {
    super(env);
  }
}

export const setEnvironment = ({
  DAIRY_RATION_URL,
  LABRESULT_URL,
  ...env
}: AgrProcessEnv): Environment =>
  new Environment({
    DAIRY_RATION_URL,
    LABRESULT_URL,
    ...setAgrEnvironment(env),
  });
